function getSection (section) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }

  return window.fetch(`${process.env.VUE_APP_API_URL}/faq&section=${section}`, requestOptions)
    .then(function (response) {
      return response.text().then(text => {
        const data = text && JSON.parse(text)
        return data
      })
    })
}
export const faqService = {
  getSection
}